import { render, staticRenderFns } from "./ChipCardToothbrush.vue?vue&type=template&id=f86baebc&"
import script from "./ChipCardToothbrush.vue?vue&type=script&lang=js&"
export * from "./ChipCardToothbrush.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports